export function parseJson(valor: any, valorPorDefecto: any) {
    if (typeof valor !== "string") {
        return valor
    }

    try {
        return JSON.parse(valor)
    } catch {
        return valorPorDefecto
    }
}
